import type { TranslationKey } from '@/lib/i18n';

export const CART_ITEM_ACCESSIBILITY_DECREASE = [
  'common:cartItem.decreaseQuantity',
  'Decrease quantity',
] as const satisfies TranslationKey;

export const CART_ITEM_ACCESSIBILITY_INCREASE = [
  'common:cartItem.increaseQuantity',
  'Increase quantity',
] as const satisfies TranslationKey;

export const CART_ITEM_REMOVE = [
  'sidecart:cart.remove',
  'Remove',
] as const satisfies TranslationKey;
